module.exports = __webpack_public_path__ + "img/eric_pink-tuerkis_ocular.0dc6f98a.jpg";